// services/api.js
const API_BASE_URL = '/api'
class ApiService {
    constructor() {
        this.baseURL = API_BASE_URL
        // کد وضعیت HTTP آخرین درخواست (0 = خطای شبکه) — ویوهای جزئیات با آن
        // «404 واقعی» را از «خطای سرور/شبکه» تفکیک می‌کنند تا noindex فقط
        // برای URLهای واقعاً ناموجود زده شود، نه هنگام قطعی API/دیتابیس
        this.lastStatus = 0
    }

    async request(endpoint, options = {}) {
        try {
            const url = `${this.baseURL}${endpoint}`
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers
                },
                ...options
            })

            if (!response.ok) {
                const err = new Error(`HTTP error! status: ${response.status}`)
                err.status = response.status
                throw err
            }
            this.lastStatus = response.status
            return await response.json()
        } catch (error) {
            // 0 = خطای شبکه، 5xx = خطای سرور، 404 = واقعاً ناموجود
            this.lastStatus = error && typeof error.status === 'number' ? error.status : 0
            console.error('API request failed:', error)
            // بازگشت به داده تستی در صورت خطا
            // return this.getFallbackData(endpoint)
        }
    }

    // لیگ‌ها
    async getLeagues() {
        return this.request('/leagues')
    }

    async getLeagueById(id) {
        return this.request(`/leagues/${id}`)
    }

    // تیم‌ها
    async getTeams() {
        return this.request('/teams')
    }

    async getTeamById(id) {
        return this.request(`/teams/${id}`)
    }

    // جستجوی تیم (انتخابگر مقایسه)
    async searchTeams(q, take = 8) {
        return this.request(`/teams/search?q=${encodeURIComponent(q)}&take=${take}`)
    }

    // مقایسه دو تیم (a و b: id یا slug)
    async compareTeams(a, b) {
        return this.request(`/teams/compare?a=${encodeURIComponent(a)}&b=${encodeURIComponent(b)}`)
    }

    // آمار فصل یک تیم (گلزنان/پاسورها + سطر جدول)
    async getTeamStats(key) {
        return this.request(`/teams/${key}/stats`)
    }

    // برترین بازیکنان یک رقابت از رویدادهای محلی
    async getCompetitionTopPlayers(id, seasonId = null) {
        const q = seasonId ? `?seasonId=${seasonId}` : ''
        return this.request(`/competition/${id}/top-players${q}`)
    }

    // مسابقات
    async getMatches({
                         date = null,
                         competitionId = null,
                         seasonId = null,
                         status = null
                     } = {}) {

        const params = new URLSearchParams()

        if (date) {
            params.append('date', date)
        }

        if (competitionId) {
            params.append('competitionId', competitionId)
        }

        if (seasonId) {
            params.append('seasonId', seasonId)
        }

        if (status) {
            params.append('status', status)
        }

        const query = params.toString()

        return this.request(
            `/matches${query ? `?${query}` : ''}`
        )
    }

    // مسابقات امروز
    async getTodayMatches() {
        return this.request('/matches/today')
    }

    async getLiveMatches() {
        return this.request('/matches/live')
    }

    async getMatchById(id) {
        return this.request(`/matches/${id}`)
    }

    // بازیکنان
    async getPlayers() {
        return this.request('/players')
    }

    async getPlayerById(id) {
        return this.request(`/players/${id}`)
    }

    // اخبار
    async getNews({ page = 1, limit = 20, source = null, search = null } = {}) {
        const params = new URLSearchParams({ page, limit })
        if (source) params.append('source', source)
        if (search) params.append('search', search)
        return this.request(`/news?${params.toString()}`)
    }

    async getHotNews() {
        return this.request('/news/hot')
    }

    async getNewsById(id) {
        return this.request(`/news/${id}`)
    }

    async getNewsSources() {
        return this.request('/news/sources')
    }

    async triggerNewsFetch() {
        return this.request('/news/fetch', { method: 'POST' })
    }

    // ویدئوها
    async searchVideos(query) {
        return this.request(`/videos/search?q=${encodeURIComponent(query)}`)
    }

    // جدول لیگ
    async getLeagueTable(leagueId) {
        console.log('[API Service] ارسال به بک‌اند:', leagueId);
        return this.request(`/sports/leagues/${leagueId}/table`);
    }

    async getAvailableLeagues() {
        return this.request('/sports/leagues');
    }

    // داده تستی برای وقتی API در دسترس نیست
    getFallbackData(endpoint) {
        const fallbackData = {
            '/leagues': [
                { id: 1, name: 'لیگ برتر ایران', country: 'ایران' },
                { id: 2, name: 'لیگ قهرمانان اروپا', country: 'اروپا' }
            ],
            '/teams': [
                { id: 1, name: 'پرسپولیس', leagueId: 1, logo: '' },
                { id: 2, name: 'استقلال', leagueId: 1, logo: '' }
            ],
            '/matches': [
                {
                    id: 1,
                    leagueId: 1,
                    team1Id: 1,
                    team2Id: 2,
                    score: '2-1',
                    status: 'finished',
                    team1: { name: 'پرسپولیس' },
                    team2: { name: 'استقلال' }
                }
            ],
            '/news': [
                {
                    id: 1,
                    title: 'پیروزی پرسپولیس در شهرآورد',
                    summary: 'شکست استقلال با نتیجه ۲-۱',
                    category: 'فوتبال داخلی',
                    imageUrl: '',
                    views: 12543
                }
            ]
        }

        return fallbackData[endpoint] || []
    }

    // آمار و دسته‌بندی
    async getPopularNews(limit = 8) {
        const res= this.request(`/stats/popular?limit=${limit}`);
        return res.data;

    }

    async getCategories() {
        return this.request('/stats/categories')
    }

    async getTags() {
        return this.request('/stats/tags')
    }

// اخبار ادمین
    async adminCreateNews(newsData) {
        return this.request('/admin/news', {
            method: 'POST',
            body: JSON.stringify(newsData)
        });
    }

    async adminGetNews() {
        return this.request('/admin/news');
    }

    async adminUpdateNews(id, newsData) {
        return this.request(`/admin/news/${id}`, {
            method: 'PUT',
            body: JSON.stringify(newsData)
        });
    }

    async adminDeleteNews(id) {
        return this.request(`/admin/news/${id}`, {
            method: 'DELETE'
        });
    }

    // آمار ادمین
    async adminGetStats() {
        return this.request('/admin/stats');
    }

    // سیدینگ
    async adminSeedData() {
        return this.request('/admin/seed', {
            method: 'POST'
        });
    }

    // لیگ‌ها
    async getCompetitions() {
        return this.request('/api/competition')
    }

    async getTopLeagues() {
        return this.request('/competition/top')
    }

    // مسابقات امروز
}


export default new ApiService()